import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogCreateCustomCodeComponent } from '@app/shared/components/dialog-create-custom-code/dialog-create-custom-code.component';
import { RuleEditorComponent } from '@app/shared/components/rule-editor/rule-editor.component';
import { CustomCodeService } from '@app/shared/services/custom-codes/custom-code.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DialogDeleteRulesetComponent } from '../../components/dialog-delete-ruleset/dialog-delete-ruleset.component';

@Component({
  standalone: false,
  selector: 'sbnb-custom-code-detail',
  templateUrl: './custom-code-detail.component.html',
  styleUrls: ['./custom-code-detail.component.scss'],
})
export class CustomCodeDetailComponent implements OnInit {
  ccId: any;
  ccData: any;
  loading: boolean;
  saveStatus: number;
  lastSaved: Date;
  conditionsMeta: any;

  updateDebouncer: Subject<any> = new Subject();

  @ViewChild('ruleEditor') ruleEditor: RuleEditorComponent;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private customCodeService: CustomCodeService,
    private dialog: MatDialog,
    private router: Router,
    private titleService: TitleService
  ) {}

  ngOnInit() {
    this.titleService.manuallySet('Custom code');
    this.loading = true;

    this.route.params.subscribe((params) => {
      this.ccId = params['id'];
      this.customCodeService.getCustomCodeById(this.ccId).subscribe((res) => {
        this.ccData = res.data;
        this.conditionsMeta = res.meta;
        this.titleService.manuallySet(this.ccData.key);
        this.loading = false;
      });
    });

    this.updateDebouncer.pipe(debounceTime(2000)).subscribe((notUsed) => {
      this.updateCc();
    });
  }

  goBack() {
    this.router.navigate(['/gx/custom-codes']);
  }

  textUpdated(newMessage: string) {
    this.ccData.updatedText = newMessage;
    this.updateDebouncer.next(null);
  }

  updateCc() {
    this.saveStatus = 1;

    const payload = Object.assign({}, this.ccData);

    if (payload.updatedText) {
      payload.text = payload.updatedText;
    }

    this.customCodeService.updateCustomCode(this.ccId, payload).subscribe((res: any) => {
      if (res.error) {
        this.saveStatus = -1;
      } else {
        this.saveStatus = 2;
        this.lastSaved = new Date();
      }
    });
  }

  copyCc() {
    this.dialog.open(DialogCreateCustomCodeComponent, {
      width: '900px',
      height: '80%',
      maxHeight: '90vh',
      data: {
        routeOnCreate: true,
        rule: this.ccData,
      },
    });
  }

  deleteCcPrompt() {
    const dialogRef = this.dialog.open(DialogDeleteRulesetComponent, {
      width: '720px',
      data: {
        item: 'Custom code',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteCc();
      }
    });
  }

  deleteCc() {
    this.customCodeService.deleteCustomCode(this.ccId).subscribe((res) => {
      this.location.back();
    });
  }

  saveStatusChange($event) {
    this.saveStatus = $event;

    if ($event === 2) {
      this.lastSaved = new Date();
    }
  }

  handleScopeChange(event) {
    this.ccData.all_platforms = event.all_platforms;
    this.ccData.all_hosts = event.all_hosts;
    this.ccData.all_properties = event.all_properties;
    this.ccData.properties = event.properties;
    this.ccData.hosts = event.hosts;
    this.ccData.platforms = event.platforms;

    this.updateCc();

    setTimeout(() => {
      this.ruleEditor.getImportableData('customCode');
    }, 3000);
  }

  handleConditionUpdate(newScopeKeys) {
    this.ccData.all_conditions = newScopeKeys.all_conditions;
    this.ccData.condition = newScopeKeys.condition;

    this.updateCc();
  }
}
